import React, { useEffect, useState } from 'react';
import {
  Typography, Paper, Table, TableHead, TableRow,
  TableCell, TableBody, Button, Box
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import API_URL from '../../settings';
import { useAuth } from '../../context/AuthContext';

function EventList() {
  const [events, setEvents] = useState([]);
  const { user } = useAuth();

  useEffect(() => {
    fetch(`${API_URL}/events?_sort=event_date&_order=desc&hospital_id=${user.hospital_id}`)
      .then(res => res.json())
      .then(setEvents);
  }, []);

  return (
    <Paper sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="h4" fontWeight="bold">
          รายการแจกของ
        </Typography>

        <Button
          variant="contained"
          component={RouterLink}
          to="/events/new"
        >
          สร้าง Event
        </Button>
      </Box>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ชื่อกิจกรรม</TableCell>
            <TableCell>วันที่</TableCell>
            <TableCell align="center">จัดการ</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {events.map(e => (
            <TableRow key={e.id}>
              <TableCell>{e.title}</TableCell>
              <TableCell>{e.event_date}</TableCell>
              <TableCell align="center">
                <Button
                  size="small"
                  variant="outlined"
                  component={RouterLink}
                  to={`/events/${e.id}`}
                >
                  เข้า Event
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

export default EventList;
